import { Component, Input } from '@angular/core';
import { NavParams } from '@ionic/angular';

import { InitConstant, DialogConstant } from '../../Constant';

import { AuthService } from '../../service/auth.service';
import { ApiService } from '../../service/api.service';
import { ProfileService } from '../../service/profile.service';
import { DialogService } from '../../service/dialog.service';
import { LogService } from '../../service/log.service';
import { EventService } from '../../service/event.service';

@Component({
    selector: 'app-profileedit-modal',
    templateUrl: './profileedit-modal.page.html',
    styleUrls: ['./profileedit-modal.page.scss'],
})
export class ProfileeditModalPage
{
    private isdisabled = false;
    private type = "";
    private type_name = "";
    private title = "";
    private min_size = 0;
    private max_size = 0;
    private size = 0;
    private value = "";
    private confirm_value = "";
    private step = 1;
    private error = "";
    private my_device_id = "";
    private devices = [];
    private remove_devices = [];

    constructor(
        private navParams: NavParams,
        private auth: AuthService,
        private api: ApiService,
        private profile: ProfileService,
        private dialog: DialogService,
        private log: LogService,
        private event: EventService
    )
    {
    }

    async ngOnInit()
    {
        await this.profile.getProfiles();

        this.type = this.navParams.data.type;
        this.title = this.navParams.data.title;
        this.min_size = this.navParams.data.min_size;
        this.max_size = this.navParams.data.max_size;
        this.size = this.navParams.data.size;

        this.event.modal_subject.next({key: "modalSubscribe", id: `${this.type}-modal`, value: null});

        switch (this.type) {
            case "displayname":
                this.type_name = "表示名";
                this.value = this.profile.getDisplayName();
                break;
            case "email":
                this.type_name = "メールアドレス";
                this.value = this.profile.getEmail();
                break;
            case "password":
                this.type_name = "パスワード";
                this.setDisabled(true);
                break;
            case "device":
                this.setDisabled(true);
                this.my_device_id = this.profile.getMyDeviceId();
                this.devices = this.profile.getDevices();
                break;
            default:
                break;
        }
    }

    async profileSend()
    {
        const btn1 = {
            text: DialogConstant.BUTTON_CANCEL,
            role: 'cancel'
        };

        const btn2 = {
            text: DialogConstant.BUTTON_OK,
            handler: async() => {
                if (this.isdisabled === true) return;
                this.setDisabled(true);

                if (this.type == "displayname") {
                    await this.api.updatename(this.value);

                    if (!this.api.isSuccess(`updatename`)) {
                        this.error = this.api.getErrorMessage(`updatename`);
                        this.setDisabled(false);
                    } else {
                        this.setDisabled(false);
                        this.event.modal_subject.next({key: "closeModal", id: `${this.type}-modal`, value: { value: "" }});
                    }
                } else if (this.type == "email") {
                    const resp_data = await this.api.updateemail(this.value);

                    if (!this.api.isSuccess(`updateemail`)) {
                        this.error = this.api.getErrorMessage(`updateemail`);
                        this.setDisabled(false);
                    } else {
                        if (resp_data.update == 1 && !this.auth.empty(this.value)) {
                            const btn1 = {
                                text: DialogConstant.BUTTON_OK,
                                handler: () => {
                                    this.setDisabled(false);
                                    this.event.modal_subject.next({key: "closeModal", id: `${this.type}-modal`, value: { value: this.value }});
                                }
                            };

                            this.dialog.confirm(DialogConstant.INFO_TITLE, DialogConstant.PROFILE_EMAIL_CONFIRM_MESSAGE, [btn1]);
                        } else {
                            this.setDisabled(false);
                            this.event.modal_subject.next({key: "closeModal", id: `${this.type}-modal`, value: { value: this.value }});
                        }
                    }
                } else if (this.type == "password") {
                    await this.api.updatepassword(this.value);

                    if (!this.api.isSuccess(`updatepassword`)) {
                        this.error = this.api.getErrorMessage(`updatepassword`);
                        this.setDisabled(false);
                    } else {
                        this.setDisabled(false);
                        this.event.modal_subject.next({key: "closeModal", id: `${this.type}-modal`, value: { value: "" }});
                    }
                }
            }
        };

        const msg = DialogConstant.UPDATE_PROFILE_BULK_COFIRM.replace("{NAME}", this.type_name);

        this.dialog.confirm(DialogConstant.CONFIRM_TITLE, msg, [btn1, btn2]);
    }

    profileConfirm()
    {
        if (this.isdisabled === true) return;
        this.setDisabled(true);
        this.step = 2;
    }

    profileBack()
    {
        this.setDisabled(true);
        this.step = 1;
    }

    profileOnChange(event)
    {
        this.value = event.detail.value;
    }

    profileOnPassChange(event)
    {
        const val = event.detail.value;

        if (val.length == 0 || val.length < this.min_size) {
            this.setDisabled(true);
            this.error = DialogConstant.UPDATE_PROFILE_PASSWORD_SIZE_ERROR.replace("{SIZE}", String(this.min_size));
        } else {
            if (this.step == 1) {
                this.value = val;
                this.setDisabled(false);
                this.error = "";
            } else {
                this.confirm_value = val;

                if (this.value != this.confirm_value) {
                    this.setDisabled(true);
                    this.error = DialogConstant.UPDATE_PROFILE_PASSWORD_UNMATCH_ERROR;
                } else {
                    this.setDisabled(false);
                    this.error = "";
                }
            }
        }
    }

    profileOnDeviceChange(id)
    {
        const index = this.remove_devices.indexOf(id);

        if (index >= 0) {
            this.remove_devices.splice(index, 1);
        } else {
            this.remove_devices.push(id);
        }

        if (this.remove_devices.length > 0) {
            this.setDisabled(false);
        } else {
            this.setDisabled(true);
        }
    }

    profileDeviceremove()
    {
        const btn1 = {
            text: DialogConstant.BUTTON_CANCEL,
            role: 'cancel'
        };

        const btn2 = {
            text: DialogConstant.BUTTON_OK,
            handler: async() => {
                this.setDisabled(true);

                await this.api.updatedevice(this.remove_devices);

                // 通信エラーの場合
                if (!this.api.isSuccess(`updatedevice`)) {
                    const err_msg = this.api.getErrorMessage(`updatedevice`);
                    this.dialog.message(DialogConstant.ERROR_TITLE, err_msg, DialogConstant.BUTTON_OK);
                    return false;
                }

                this.setDisabled(false);
                this.event.modal_subject.next({key: "closeModal", id: `${this.type}-modal`, value: { value: "" }});
            }
        };

        this.dialog.confirm(DialogConstant.CONFIRM_TITLE, DialogConstant.UPDATE_PROFILE_DEVICE_COFIRM, [btn1, btn2]);
    }

    setDisabled(disable)
    {
        this.isdisabled = disable;
    }

    profileClose()
    {
        this.event.modal_subject.next({key: "closeModal", id: `${this.type}-modal`, value: null});
    }
}
